<template>
  <div>
    <div class="user__vault" v-if="isMyself">
      <v-icon class="user__vault--icon" style="font-size: 50px">business_center</v-icon>
      <div class="vault__text">
        <vue-markdown :source="description">
        </vue-markdown>
      </div>
    </div>

    <v-container>
      <div class="user-edit__section" v-if="isMyself">
        <v-btn flat :loading="uploading" class="upload-button" @click="onFilePick">Upload File to Vault</v-btn>
        <input
          @change="onFilePicked"
          type="file"
          accept="*/*"
          style="display: none;"
          ref="vaultUploader"
        >
      </div>

      <div class="private__data">
        <span @click="showGallery(index)" class="image-list" v-for="(image, index) in uploads" :key="image.data_object_id">
          <imager :src="createThumbnailUrl(image.data_url)" :styles="{'min-width': '124px', 'max-height': '124px'}">
            <loader></loader>
          </imager>
          <a :href="image.data_url" download target="_blank">
            <v-btn icon class="image-list-button" @click.stop>
              <img src="~icons/download.svg"></img>
            </v-btn>
          </a>
        </span>
      </div>

      <no-data-message v-if="noData">
        <v-icon slot="icon">business_center</v-icon>
        <div slot="message">
          There are no uploads in the file vault
        </div>
        <div slot="sub-message">
          There are no uploads to show as there are no files uploaded at this time.
        </div>
      </no-data-message>
    </v-container>
  </div>
</template>

<script>
import get from 'lodash/get';
import VueMarkdown from 'vue-markdown';

import uploader from '@/mixins/uploader';
import { getSystemText } from '@/api';
import Imager from '@/components/Imager';

import audioThumbnail from 'icons/audio-thumbnail.png';
import videoThumbnail from 'icons/video-thumbnail.png';
import documentThumbnail from 'icons/document-thumbnail.png';
import { identifyFileType, FILE_TYPES } from '@/utils/file_type';

export default {
  mixins: [uploader],
  components: {
    VueMarkdown,
    Imager,
  },
  props: {
    profile: Object,
  },
  data() {
    return {
      uploading: false,
      description: '',
    };
  },
  computed: {
    userId() {
      return this.$route.params.id || this.$store.getters['auth/userId'];
    },
    isMyself() {
      return this.userId === this.$store.getters['auth/userId'];
    },
    uploads() {
      return get(this.profile, 'user_data_private', []);
    },
    noData() {
      return this.uploads.length === 0;
    },
  },
  methods: {
    onFilePick() {
      this.$refs.vaultUploader.click();
    },
    onFilePicked: async function _onFilePicked(event) {
      const files = event.target.files;
      const file = files[0];
      this.uploading = true;
      const data = await this.uploadMedia(file, { user_profile: 1 }, 1);
      this.uploading = false;
      const profile = { ...this.profile };
      profile.user_data_private.push(data);
      this.profile = { ...profile };
    },
    fetchFileVaultText: async function _fetchFileVaultText() {
      const token = this.$store.getters['auth/userToken'];
      const { data } = await getSystemText(token, 'user_edit_private_data_heading');
      this.description = get(data, '[1].data.details.text', '');
    },
    showGallery(index) {
      const imageUrls = [];
      for (let i = 0; i < this.uploads.length; i += 1) {
        imageUrls.push(this.uploads[i].data_url);
      }
      this.$store.dispatch('gallery/setImages', imageUrls);
      this.$store.dispatch('gallery/showGallery', { show: true, active: index });
    },
    createThumbnailUrl(url) {
      /* eslint global-require: "warn" */
      const fileType = identifyFileType(url);
      switch (fileType) {
        case FILE_TYPES.IMAGE:
          return url;
        case FILE_TYPES.VIDEO:
          return videoThumbnail;
        case FILE_TYPES.AUDIO:
          return audioThumbnail;
        default:
          return documentThumbnail;
      }
    },
  },
  mounted() {
    this.fetchFileVaultText();
  },
};
</script>


<style lang="scss" scoped>
@import "~styles/shared.scss";

.user__vault {
  background: $lighter;
  padding: 20px 30px;
  padding-bottom: 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.user__vault--icon {
  margin-bottom: 16px;
}

.vault__text {
  font-size: 18px;
  margin-left: 30px;
}

.vault__link {
  text-decoration: none;
  color: $blue;
}

.upload-button {
  margin-top: 20px;
  width: 100%;
  border-radius:28px 28px 28px 28px;
  min-height: 48px;
  box-shadow: 0 2px 6px 0.5px $border-color;
  margin-bottom: 10px;
  background-color: white;
  color: $white;
  font-weight: bold;
  background: $primary !important;
}

.image-list {
  position: relative;
  display: inline-block;
  padding: 1px;
}

.image-list .image-list-button {
  background: $white;
  position: absolute;
  right: 0;
  bottom: 0;
  margin-right: 10px;
  margin-bottom: 10px;
}

.private__data {
  margin-top: 15px;
}
</style>




// WEBPACK FOOTER //
// src/components/UserVault.vue